<adapt-dialog [maxWidth]="1100">
    <h3 adapt-dialog-title>Capture a Peer Catch-up</h3>

    <ng-container adapt-dialog-content>
        <ol class="step-progress-bar">
            @for (progressStep of progressSteps; track progressStep) {
                <li [ngClass]="progressStep.stepClass">
                    {{ progressStep.label }}
                </li>
            }
        </ol>

        <div class="edit-catchup row gy-3">
            @if (guidanceText) {
                <div [adaptCollapsible]="guidanceType"
                     class="col-12 col-lg-5">
                    <div [froalaView]="guidanceText"
                         [disableViewCallbacks]="true"
                         class="p-3 pe-0"></div>
                </div>
            }

            <div class="col-12"
                 [ngClass]="{ 'col-lg-7 ps-lg-4': !!guidanceText }">
                @if (!currentRatingType) {
                    <adapt-edit-catchup-people [catchup]="catchup"
                                               (validationChange)="nextButtonDisabled = !$event"></adapt-edit-catchup-people>
                } @else {
                    <adapt-edit-catchup-rating-type [catchup]="catchup"
                                                    [ratingType]="currentRatingType"
                                                    [isEditing]="true"
                                                    (ratingChange)="validateCurrentRatingType()"></adapt-edit-catchup-rating-type>
                }

                @if (!hideActionButton && filteredLinks.length) {
                    <adapt-collapsible-dashboard-element [collapsed]="false"
                                                         name="Associated actions">
                        @for (link of catchup.links; track link) {
                            <adapt-display-action-link [link]="link"
                                                       [itemLinksDisabled]="true"
                                                       [closeAllDialogsOnDelete]="false"
                                                       (itemDialogClosed)="updateLinks($event)"> </adapt-display-action-link>
                        }
                    </adapt-collapsible-dashboard-element>
                }
            </div>
        </div>
    </ng-container>

    <ng-container adapt-dialog-footer>
        @if (!hideActionButton && hasEditableBoard) {
            <button class="btn-item-add"
                    adaptButton="add"
                    [adaptBlockingClick]="addAction">action</button>
        }
        <div adaptBlockingButtonGroup
             class="ms-auto">
            <button adaptButton="previous"
                    [adaptBlockingClick]="activatePrevious"
                    [disabled]="previousButtonDisabled"></button>
            @if (!isLastStep) {
                <button adaptButton="next"
                        [adaptBlockingClick]="activateNext"
                        [disabled]="nextButtonDisabled"></button>
            }
            @if (isLastStep) {
                <button adaptButton="saveAndReview"
                        [adaptBlockingClick]="saveAndReview"
                        [disabled]="nextButtonDisabled"
                        data-test="standard-dialog-save-button"></button>
            }
            <button adaptButtonIcon="default"
                    (click)="cancel()"
                    data-test="standard-dialog-cancel-button">Cancel</button>
        </div>
    </ng-container>
</adapt-dialog>

<ng-template #linkTemplate></ng-template>
